import { useEffect, useState } from "react";
import { getAttractionTicket } from "@/lib/attractionsApi";
import { useToast } from "@/hooks/use-toast";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Badge } from "@/components/ui/badge";

interface TicketViewModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  ticketId?: number;
  attractionId?: number;
}

const TicketViewModal = ({ open, onOpenChange, ticketId, attractionId }: TicketViewModalProps) => {
  const { toast } = useToast();
  const [ticket, setTicket] = useState<any>(null);

  const formatPricingType = (type: string) => {
    const types: Record<string, string> = {
      'per_person': 'Per Person',
      'per_family': 'Per Family',
      'per_group': 'Per Group'
    };
    return types[type] || type;
  };

  useEffect(() => {
    if (open && ticketId) {
      loadTicketData();
    }
  }, [open, ticketId, attractionId]);

  const loadTicketData = async () => {
    if (!ticketId || !attractionId) return;
    
    try {
      const data = await getAttractionTicket(attractionId, ticketId);
      setTicket(data);
    } catch (error: any) {
      toast({
        title: "Error",
        description: error.message,
        variant: "destructive",
      });
    }
  };

  if (!ticket) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>View Ticket Details</DialogTitle>
        </DialogHeader>

        <div className="space-y-4">
          <div className="flex items-center gap-2">
            <Label>Pricing Type:</Label>
            <Badge variant="secondary">{formatPricingType(ticket.pricing_type)}</Badge>
          </div>

          <div className="space-y-2">
            <Label>Title</Label>
            <Input value={ticket.title || ""} disabled />
          </div>

          <div className="space-y-2">
            <Label>Description</Label>
            <Textarea value={ticket.description || ""} disabled rows={3} />
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label>Cost Supplier</Label>
              <Input value={ticket.cost_supplier?.toString() || ""} disabled />
            </div>
            <div className="space-y-2">
              <Label>Website Price</Label>
              <Input value={ticket.website_price?.toString() || ""} disabled />
            </div>
          </div>

          <div className="grid grid-cols-3 gap-4">
            <div className="space-y-2">
              <Label>Price OP</Label>
              <Input value={ticket.price_op?.toString() || ""} disabled />
            </div>
            <div className="space-y-2">
              <Label>Price AG</Label>
              <Input value={ticket.price_ag?.toString() || ""} disabled />
            </div>
            <div className="space-y-2">
              <Label>Price CF</Label>
              <Input value={ticket.price_cf?.toString() || ""} disabled />
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default TicketViewModal;
